module.exports = __webpack_public_path__ + "77f1607c45137518aa24236c706ce912.png";


//////////////////
// WEBPACK FOOTER
// ../images/admin/campaign_wrap_up/locations/world.png
// module id = 3276
// module chunks = 69